import { render } from "./AlMenu.vue?vue&type=template&id=6d26f633&scoped=true"
const script = {}

import "./AlMenu.vue?vue&type=style&index=0&id=6d26f633&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d26f633"]])

export default __exports__